const MONTH_LABELS = [
  'Januar', 'Februar', 'Marts', 'April', 'Maj', 'Juni',
  'Juli', 'August', 'September', 'Oktober', 'November', 'December'
]

export function previousMonthParts() {
  const d = new Date()
  d.setDate(1)
  d.setMonth(d.getMonth() - 1)
  return { year: d.getFullYear(), month: d.getMonth() + 1 }
}

export function buildPeriodOptions(count = 12) {
  const options = []
  const d = new Date()
  d.setDate(1)
  for (let i = 0; i < count; i += 1) {
    const year = d.getFullYear()
    const month = d.getMonth() + 1
    options.push({
      value: `${year}-${month}`,
      label: `${MONTH_LABELS[month - 1]} ${year}`,
      year,
      month
    })
    d.setMonth(d.getMonth() - 1)
  }
  return options
}

export function periodValue(year, month) {
  return `${year}-${month}`
}

export function parsePeriodValue(value) {
  const parts = String(value || '').split('-')
  const year = parseInt(parts[0], 10)
  const month = parseInt(parts[1], 10)
  if (Number.isNaN(year) || Number.isNaN(month)) {
    return null
  }
  return { year, month }
}

export function monthLabel(month, { lowercase = false } = {}) {
  const label = MONTH_LABELS[month - 1] || ''
  return lowercase ? label.toLowerCase() : label
}

export function startParam(year, month) {
  return `${year}-${month}-1`
}

export { MONTH_LABELS }
